import React, { useCallback } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { testIdConcat } from '@atlassian/jira-navigation-apps-common/src/utils/test-id.tsx';
import { usePlansItems } from '@atlassian/jira-plans-item-store/src/index.tsx';
import { useCreateNewPlanWizardDrawer } from '@atlassian/jira-portfolio-3-create-new-plan-wizard-drawer/src/controllers/index.tsx';
import { useCreateSamplePlan } from '@atlassian/jira-portfolio-3-create-sample-plan/src/controllers/index.tsx';
import { MenuItem } from './menu-item/index.tsx';
import messages from './messages.tsx';
import type { ActionFooterProps } from './types.tsx';
import { useIsPlanListEmpty } from './utils.tsx';

export const ActionFooter = ({ testIdPrefix }: ActionFooterProps) => {
	const { formatMessage } = useIntl();
	const [{ items }] = usePlansItems();
	const isPlanListEmpty = useIsPlanListEmpty();
	const testId = testIdConcat(testIdPrefix, 'action-footer');
	const [, { openDrawer: openCreateNewPlanWizardDrawer }] = useCreateNewPlanWizardDrawer();
	const [, { open: openCreateSamplePlanModal }] = useCreateSamplePlan();

	const onClick = useCallback(() => {
		openCreateNewPlanWizardDrawer();
	}, [openCreateNewPlanWizardDrawer]);

	if (!items || !items.links) {
		return null;
	}

	const { links } = items;
	const { managePlans, createPlan, createSamplePlan } = links;

	const isAnyItemVisible = managePlans.isVisible || createPlan.isVisible;

	if (!isAnyItemVisible) return null;

	return (
		<span data-testId={testId}>
			<MenuItem
				{...links.managePlans}
				title={formatMessage(messages.managePlans)}
				testIdPrefix={testIdPrefix}
			/>
			<MenuItem
				id={links.createPlan.id}
				isVisible={links.createPlan.isVisible && !isPlanListEmpty}
				title={formatMessage(messages.createPlan)}
				testIdPrefix={testIdPrefix}
				onClick={onClick}
			/>
			{createSamplePlan && (
				<MenuItem
					id={createSamplePlan.id}
					isVisible={createSamplePlan.isVisible && !isPlanListEmpty}
					title={formatMessage(messages.createDemoPlan)}
					testIdPrefix={testIdPrefix}
					onClick={openCreateSamplePlanModal}
				/>
			)}
		</span>
	);
};
